import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-book-services-icon',
  templateUrl: './book-services-icon.component.html',
  styleUrls: ['./book-services-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookServicesIconComponent {
  constructor() {}
}
